import { useEffect, useState, useCallback } from "react";
import friendshipService from "../services/friendshipService";

const useFriends = () => {
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = friendshipService.subscribeFriends((list) => {
      setFriends(list); // already ordered by intimacy.score desc in service
      setLoading(false);
    });
    return () => unsubscribe?.();
  }, []);

  const removeFriend = useCallback(async (friendId) => {
    setError(null);
    try {
      await friendshipService.removeFriend(friendId);
    } catch (e) {
      setError(e.message || "Failed to remove friend");
      throw e;
    }
  }, []);

  return {
    friends,
    loading,
    error,
    removeFriend,
    hasFriends: friends.length > 0,
  };
};

export default useFriends;